module.exports = __webpack_public_path__ + "img/route-marker-start.139ad0d9.svg";